import {
  Radio,
  RadioGroup,
  Stack,
  Text,
  useModalState,
  useRadioState,
} from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { FULFILLMENT, MARKETPLACE, type Origin as OriginType } from 'typings'
import { useFormStateContext } from '../../../providers'
import { ChangeOriginWarningModal } from './ChangeOriginWarningModal'
import { messages } from './messages'

type Props = {
  name: string
}
export function Origin(props: Props) {
  const { name } = props
  const { formatMessage: i18n } = useIntl()

  const { form } = useFormStateContext()
  const origin: OriginType = useWatch({ form, name })

  const radioState = useRadioState({ value: origin })
  const changeOriginModalState = useModalState()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === FULFILLMENT) {
      changeOriginModalState.show()
    } else {
      form.setValue(name, e.target.value)
    }
  }

  const handleFulfillmentChangeConfirmation = () => {
    form.setValue(name, FULFILLMENT)
    changeOriginModalState.hide()
  }

  return (
    <>
      <Stack space="$space-5" fluid>
        <Text variant="title1">
          <FormattedMessage id="admin/promotions.form.origin.title" />
        </Text>

        <RadioGroup label="" state={radioState} onChange={handleChange}>
          <Radio label={i18n(messages.marketplace)} value={MARKETPLACE} />

          <Radio label={i18n(messages.fulfillment)} value={FULFILLMENT} />
        </RadioGroup>
      </Stack>

      <ChangeOriginWarningModal
        state={changeOriginModalState}
        onCancel={changeOriginModalState.hide}
        onConfirm={handleFulfillmentChangeConfirmation}
      />
    </>
  )
}
